const RUNNER_ERROR_MESSAGES: Record<string, string> = {
    RunnerResponseTimeout: 'ERROR: Request timed out while waiting for a response from the configured remote runner.',
    InvokeFailedOnRunner: 'ERROR: The invocation failed on the remote runner.',
    RunnerNotAvailable: 'ERROR: The configured remote runner appears to be unavailable.',
};

export interface ParsedError {
    message: string;
    errorType?: string;
}

export async function parseErrorResponse(resp: Response): Promise<ParsedError> {
    let message = '';
    try {
        message = await resp.text();
    } catch (err) {
        console.error('Failed to read error response body', err);
    }

    const normalized = message.trim() || resp.statusText || 'Request failed.';
    const errorTypeHeader = resp.headers.get('X-Error-Type');
    const errorType = errorTypeHeader ? errorTypeHeader.trim() : undefined;

    return { message: normalized, errorType };
}

export function runnerErrorMessage(errorType?: string): string | undefined {
    if (!errorType) {
        return undefined;
    }
    return RUNNER_ERROR_MESSAGES[errorType];
}
